// eslint-disable-next-line no-shadow
export enum TemplateType {
	MUSIC_VIDEO_SONGS = 'music_video_songs',
	POSE_CONTROL = 'pose_control',
	CLOTH_SWAP_GARMENTS = 'cloth_swap_garments',
	CLOTH_SWAP_TARGETS = 'cloth_swap_targets',
	CLOTH_SWAP_GUIDE = 'cloth_swap_guide',
	CHARACTER = 'character',
	OBJECT_PLACEMENT = 'object_placement',
	OBJECT_PLACEMENT_GUIDE = 'object_placement_guide',
	FLUX_REFERENCE_IMAGE = 'flux_reference_image',
}
